// ─────────────────────────────────────────────
//  Pricing — public pricing page
// ─────────────────────────────────────────────
import Nav from "../components/Nav";

const PLANS = [
  {
    name: "Starter", price: "Free", period: "forever", highlight: false,
    features: ["1 location","QR code on receipts","Up to 50 reviews/mo","Google Reviews","Basic dashboard"],
  },
  {
    name: "Pro", price: "$29", period: "/month", highlight: true,
    features: ["1 location","Unlimited reviews","Google, Yelp & TripAdvisor","Review gating","Instant alerts","Thank-you incentives","Analytics dashboard","Priority support"],
  },
  {
    name: "Business", price: "$79", period: "/month", highlight: false,
    features: ["Up to 5 locations","Everything in Pro","Multi-location dashboard","Team accounts","Custom branding on QR","API access","Dedicated account manager"],
  },
];

export default function Pricing({ goHome, goHow, goOnboard }) {
  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0f", fontFamily:"'Plus Jakarta Sans', sans-serif", color:"#f0ede8" }}>

      <Nav onHome={goHome} onHow={goHow} onPricing={() => {}} onGetStarted={goOnboard} />

      <div style={{ maxWidth:880, margin:"0 auto", padding:"70px 40px" }}>
        <div style={{ textAlign:"center", marginBottom:56 }}>
          <div style={{ fontSize:11, color:"#FF6B35", fontWeight:700, letterSpacing:"0.12em", marginBottom:12 }}>PRICING</div>
          <h1 style={{ fontSize:"clamp(28px,5vw,50px)", fontWeight:900, letterSpacing:"-0.04em", margin:"0 0 16px" }}>Simple, honest pricing</h1>
          <p style={{ color:"rgba(255,255,255,0.4)", fontSize:16, fontWeight:300 }}>Start free. Upgrade when you're ready.</p>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:18 }}>
          {PLANS.map((p) => (
            <div
              key={p.name}
              style={{
                background: p.highlight ? "rgba(255,107,53,0.1)" : "rgba(255,255,255,0.03)",
                border: `1.5px solid ${p.highlight ? "#FF6B35" : "rgba(255,255,255,0.08)"}`,
                borderRadius:20, padding:"28px 24px", position:"relative", overflow:"hidden",
              }}
            >
              {p.highlight && (
                <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(135deg,#FF6B35,#FFBE0B)" }} />
              )}
              {p.highlight && (
                <div style={{ fontSize:10, fontWeight:700, color:"#FF6B35", letterSpacing:"0.1em", marginBottom:10 }}>MOST POPULAR</div>
              )}
              <div style={{ fontSize:20, fontWeight:900, marginBottom:4 }}>{p.name}</div>
              <div style={{ display:"flex", alignItems:"baseline", gap:4, marginBottom:20 }}>
                <span style={{ fontSize:36, fontWeight:900, color: p.highlight ? "#FF6B35" : "#fff" }}>{p.price}</span>
                <span style={{ fontSize:13, color:"rgba(255,255,255,0.4)" }}>{p.period}</span>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:9, marginBottom:28 }}>
                {p.features.map((f) => (
                  <div key={f} style={{ display:"flex", gap:9, alignItems:"flex-start" }}>
                    <span style={{ color:"#FF6B35", fontSize:14, marginTop:1 }}>✓</span>
                    <span style={{ fontSize:13, color:"rgba(255,255,255,0.6)", lineHeight:1.4 }}>{f}</span>
                  </div>
                ))}
              </div>
              <button
                onClick={goOnboard}
                style={{ width:"100%", padding:"12px", borderRadius:10, border:"none", background: p.highlight ? "linear-gradient(135deg,#FF6B35,#FFBE0B)" : "rgba(255,255,255,0.08)", color: p.highlight ? "white" : "rgba(255,255,255,0.6)", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}
              >
                {p.price === "Free" ? "Start free" : "Start 30-day trial"}
              </button>
            </div>
          ))}
        </div>

        <div style={{ textAlign:"center", marginTop:32, fontSize:13, color:"rgba(255,255,255,0.3)" }}>
          All plans include a 30-day free trial · No credit card required · Cancel anytime
        </div>
      </div>
    </div>
  );
}
